/**
 * Product analytics — fire-and-forget POST to /api/analytics/event.
 *
 * Usage:
 *   import { track, trackPage, trackTool } from "../lib/analytics";
 *   track("sim_run", { tool: "timing", meta: { player_ids: [...], captain_id: 123 } });
 *   trackPage("/timing");
 *   trackTool("timing", "pool_open");
 *
 * Errors are swallowed silently — analytics must never break the app.
 * We deduplicate rapid duplicate events (< 800ms) client-side to avoid
 * accidentally logging React double-effect renders in dev.
 */
import { api } from "./api";

const _recent = new Map(); // key -> timestamp
const DEDUP_MS = 800;

export function track(event, opts = {}) {
    if (!event) return;
    const key = `${event}|${opts.tool || ""}|${opts.path || ""}|${JSON.stringify(opts.meta || {})}`;
    const now = Date.now();
    const last = _recent.get(key);
    if (last && now - last < DEDUP_MS) return;
    _recent.set(key, now);
    // Trim map so it doesn't grow unbounded
    if (_recent.size > 200) {
        const first = _recent.keys().next().value;
        _recent.delete(first);
    }
    try {
        api.post("/analytics/event", {
            event,
            tool: opts.tool || null,
            path: opts.path || null,
            meta: opts.meta || null,
        }).catch(() => { /* silent */ });
    } catch { /* silent */ }
}

export function trackPage(path) {
    track("page_view", { path: path || window.location.pathname });
}

export function trackTool(tool, subevent = "tool_open", meta = null) {
    track(subevent, { tool, meta });
}
